export default __webpack_public_path__ + "static/media/component_mini_geared_motor.07438032.png";